import React from "react";
import { useState } from "react";
import VerificationBadge from "../assets/svg/verification-badge.svg";
import { TextInput } from "../components/common/ui/Inputs";
import { Link } from "react-router-dom";
import otpSchema from "../validation/otpSchema";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import { useDispatch } from "react-redux";
import { userRegisterAction } from "../_store";
import { useLocation, useNavigate } from "react-router-dom";

function Verification() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location?.state?.email;
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);
  const [verifyOTP, setVerifyOTP] = useState({
    email: email,
    otp: "",
  });

  const submitVerifyOTP = (e) => {
    e?.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = otpSchema(verifyOTP);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    // dispatch(userRegisterAction?.verifyOTP(verifyOTP))
    //   .then((result) => {
    //     setSubmit(false);
    //     if (result?.payload?.status === 1) {
    //       showToastNotification("OTP Verified Successfully", "success");
    //       setSubmit(false);
    //       navigate("/home");
    //     } else {
    //       showToastNotification(result?.error?.message, "error");
    //     }
    //   })
    //   .catch((err) => {
    //     showToastNotification("Failed to create committee", "error");
    //     setSubmit(false);
    //   });
  };

  return (
    <>
      <section className="otp-section">
        <div className="otp-card ">
          <img
            height={"92px"}
            width={"92px"}
            src={VerificationBadge}
            alt="verification-badge"
          />
          <h1 className="otp-label">Check your inbox</h1>
          <h1 className="otp-verify-label">
            Enter the verification code we just sent to {email}.
          </h1>
          <form
            className="d-flex flex-column gap-3 align-item-center"
            onSubmit={(e) => {
              submitVerifyOTP(e);
            }}
          >
            <div className="">
              <TextInput
                name="otp"
                // label="OTP"
                label="One-Time Code"
                placeholder="Enter the One-Time Code"
                maxLength={6}
                value={verifyOTP?.otp}
                handleChange={(e) => {
                  setVerifyOTP((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
                required
                errorMessage={errorMessage}
                handleBlur={(e) => {
                  //  handleValidationForPopup(e, "categoryName");
                }}
              />
            </div>
            <div className="div-center">
              <button
                type="submit"
                className="sign-in-button"
                disabled={submit}
              >
                Verify <i className="css-arrow-icon bi bi-arrow-right"></i>
              </button>
            </div>
          </form>
          <p className="resend-link">
            Not Received Your Code?{" "}
            <Link to="/login" className="text-primary text-decoration-none">
              Login
            </Link>
          </p>
        </div>
      </section>
    </>
  );
}

export default Verification;
